import { Dijkstra } from 'features/map/utils/dijkstra';

import { LayerRouting } from '../../../appTypes';

export function getRouteCost(routing: LayerRouting, path: string[]) {
  if (!path) {
    return undefined;
  }
  let lastSeg = path[0];
  let cost = 0;
  for (let i = 1; i < path.length; i++) {
    cost += routing.forward[lastSeg][path[i]];
    lastSeg = path[i];
  }
  return cost;
}

export function getRoutingForSegmentPair(
  routing: LayerRouting,
  seg1: string,
  seg2: string,
) {
  if (!routing) return undefined;
  if (!(seg1 in routing.forward)) {
    console.error('Segment not in forward map');
  } else {
    // console.log(routing.forward[seg1]);
  }
  try {
    const path = new Dijkstra(routing.forward).find_path(seg1, seg2);
    return path;
  } catch (e) {
    return undefined;
  }
}

export function getRouteForSparseSegments(
  routing: LayerRouting,
  segments: Array<string>,
): Array<string> {
  if (!segments) {
    return [];
  }
  if (segments.length === 1) {
    return segments;
  }
  const route = [];
  for (let i = 1; i < segments.length; i++) {
    let trouting = getRoutingForSegmentPair(
      routing,
      segments[i - 1],
      segments[i],
    );
    if (trouting) {
      trouting = trouting.filter(
        (item) => routing !== null || routing !== undefined,
      );
      route.push(...trouting);
    }
  }
  const clean_route = [];
  // Very basic ordered deduplication
  for (let i = 0; i < route.length; i++) {
    if (
      clean_route.length === 0 ||
      clean_route[clean_route.length - 1] !== route[i]
    ) {
      clean_route.push(route[i]);
    }
  }
  return clean_route;
}
